/* Maison Trèfle — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.Trefle || { routes: { root: '/' }, freeShipping: 5000 };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;
  const CLOVER = '<svg class="clover" viewBox="-46 -46 92 92" aria-hidden="true" fill="currentColor"><g><path transform="rotate(42)" d="M0 -2C-13-11-21-22-16-32C-11-40-3-38 0-30C3-38 11-40 16-32C21-22 13-11 0-2Z"/><path transform="rotate(133) scale(.97)" d="M0 -2C-13-11-21-22-16-32C-11-40-3-38 0-30C3-38 11-40 16-32C21-22 13-11 0-2Z"/><path transform="rotate(227) scale(1.02)" d="M0 -2C-13-11-21-22-16-32C-11-40-3-38 0-30C3-38 11-40 16-32C21-22 13-11 0-2Z"/><path transform="rotate(316) scale(.98)" d="M0 -2C-13-11-21-22-16-32C-11-40-3-38 0-30C3-38 11-40 16-32C21-22 13-11 0-2Z"/></g><path d="M0 2C2 15 0 28-9 40" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/></svg>';
  const rootUrl = (T.routes.root || '/').replace(/\/?$/, '/');
  function formatMoney(cents, fmt) {
    fmt = fmt || '{{amount_with_comma_separator}} €';
    const n = (v, d, ts, ds) => { const p = (v / 100).toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({ amount: n(cents, 2, ',', '.'), amount_no_decimals: n(cents, 0, ',', '.'), amount_with_comma_separator: n(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: n(cents, 0, '.', ','), amount_with_space_separator: n(cents, 2, ' ', ','), amount_with_apostrophe_separator: n(cents, 2, "'", '.') }[k] || n(cents, 2, ',', '.')));
  }

  /* ---------- loader (first view of the session only) ---------- */
  const loader = $('.loader');
  try {
    if (loader && !sessionStorage.getItem('mt-seen') && !reduce) { loader.classList.add('is-on'); sessionStorage.setItem('mt-seen', '1'); }
  } catch (e) { /* storage blocked */ }
  const ready = () => { root.classList.add('is-loaded'); if (loader) setTimeout(() => loader.classList.remove('is-on'), 350); };
  if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready);
  setTimeout(ready, 2500);

  /* ---------- toast ---------- */
  const toastEl = $('.toast'); let toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.innerHTML = CLOVER + '<span></span>'; toastEl.lastChild.textContent = msg; toastEl.hidden = false;
    requestAnimationFrame(() => toastEl.classList.add('is-on'));
    clearTimeout(toastT); toastT = setTimeout(() => { toastEl.classList.remove('is-on'); setTimeout(() => { toastEl.hidden = true; }, 300); }, 2600);
  }

  /* ---------- header ---------- */
  const header = $('.header');
  const onScrollHeader = () => header && header.classList.toggle('is-scrolled', window.scrollY > 24);
  window.addEventListener('scroll', onScrollHeader, { passive: true }); onScrollHeader();

  /* ---------- overlays: menu, search, filters, cart ---------- */
  let lastFocus = null;
  function openLayer(el, cls = 'is-open') {
    if (!el) return; lastFocus = document.activeElement; el.hidden = false;
    requestAnimationFrame(() => { el.classList.add(cls); const f = el.querySelector('[data-autofocus]') || el.querySelector('input, button, a'); f && f.focus({ preventScroll: true }); });
    document.body.style.overflow = 'hidden'; if (header && el.id === 'menu') header.classList.add('is-open');
  }
  function closeLayer(el, cls = 'is-open') {
    if (!el || !el.classList.contains(cls)) return; el.classList.remove(cls); document.body.style.overflow = '';
    if (header) header.classList.remove('is-open');
    if (el.matches('[data-cart-drawer]')) setTimeout(() => { if (!el.classList.contains(cls)) el.hidden = true; }, 500);
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open]');
    if (t) { e.preventDefault(); const el = document.getElementById(t.dataset.open); openLayer(el); t.setAttribute('aria-expanded', 'true'); return; }
    const c = e.target.closest('[data-close], [data-drawer-close]');
    if (c) { const el = c.closest('.menu, .search, .filters, .drawer'); closeLayer(el); $$('[data-open][aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.menu.is-open, .search.is-open, .filters.is-open, .drawer.is-open').forEach((el) => closeLayer(el));
  });
  // keep keyboard focus inside an open dialog
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const layer = $('.menu.is-open, .filters.is-open, .drawer.is-open'); if (!layer) return;
    const f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex="0"]', layer).filter((x) => x.offsetParent !== null);
    if (!f.length) return; const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- reveal ---------- */
  const targets = $$('[data-reveal], [data-reveal-stagger], .img-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach((t) => io.observe(t));
  } else targets.forEach((t) => t.classList.add('is-in'));

  /* ---------- parallax (hero jewel + split images) ---------- */
  const para = $$('[data-parallax]');
  if (para.length && !reduce) {
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      para.forEach((el) => {
        const r = el.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
        const k = parseFloat(el.dataset.parallax) || 0.08; const p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--py', (p * -k * r.height).toFixed(1) + 'px');
        if (el.dataset.rotate) el.style.setProperty('--pr', (p * -parseFloat(el.dataset.rotate)).toFixed(2) + 'deg');
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true }); run();
  }

  /* ---------- count-up ---------- */
  const nums = $$('[data-count-to]');
  if (nums.length && 'IntersectionObserver' in window) {
    const io2 = new IntersectionObserver((ens) => ens.forEach((en) => {
      if (!en.isIntersecting) return; io2.unobserve(en.target);
      const el = en.target; const to = parseFloat(el.dataset.countTo); const suf = el.dataset.suffix || ''; const pre = el.dataset.prefix || '';
      if (reduce || !to) { el.textContent = pre + to.toLocaleString('fr-FR') + suf; return; }
      const t0 = performance.now(); const d = 1600;
      const step = (t) => { const k = Math.min(1, (t - t0) / d); const v = Math.round(to * (1 - Math.pow(1 - k, 3))); el.textContent = pre + v.toLocaleString('fr-FR') + suf; if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }), { threshold: 0.4 });
    nums.forEach((n) => io2.observe(n));
  }

  /* ---------- focus carousel (center sharp, neighbours blurred) ---------- */
  $$('[data-focus]').forEach((wrap) => {
    const track = $('.focus__track', wrap); const slides = $$('.focus__slide', track); const dots = $$('.focus__dots button', wrap);
    if (!slides.length) return;
    let active = 0;
    const setActive = (i) => {
      active = i;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.classList.toggle('is-near', Math.abs(k - i) === 1); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); $$('a, button', s).forEach((a) => a.tabIndex = k === i ? 0 : -1); });
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
    };
    const center = () => { const mid = track.scrollLeft + track.clientWidth / 2; let best = 0, bd = Infinity; slides.forEach((s, k) => { const c = s.offsetLeft + s.offsetWidth / 2; const d = Math.abs(c - mid); if (d < bd) { bd = d; best = k; } }); if (best !== active) setActive(best); };
    const go = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); const s = slides[i]; track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); setActive(i); };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(center); }, { passive: true });
    $('[data-prev]', wrap) && $('[data-prev]', wrap).addEventListener('click', () => go(active - 1));
    $('[data-next]', wrap) && $('[data-next]', wrap).addEventListener('click', () => go(active + 1));
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); } });
    const start = Math.floor(slides.length / 2);
    requestAnimationFrame(() => { const s = slides[start]; track.scrollLeft = s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2; setActive(start); });
    window.addEventListener('resize', () => go(active));
  });

  /* ---------- rails ---------- */
  $$('[data-rail]').forEach((wrap) => {
    const rail = $('.rail', wrap); if (!rail) return;
    const by = () => (rail.firstElementChild ? rail.firstElementChild.offsetWidth + 20 : 300);
    $('[data-rail-prev]', wrap) && $('[data-rail-prev]', wrap).addEventListener('click', () => rail.scrollBy({ left: -by(), behavior: 'smooth' }));
    $('[data-rail-next]', wrap) && $('[data-rail-next]', wrap).addEventListener('click', () => rail.scrollBy({ left: by(), behavior: 'smooth' }));
  });

  /* ---------- wishlist (localStorage) ---------- */
  const WKEY = 'mt-wishlist';
  const getW = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
  const setW = (a) => { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} syncW(); };
  function syncW() {
    const w = getW();
    $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', w.includes(b.dataset.wish) ? 'true' : 'false'));
    $$('[data-wish-count]').forEach((c) => { c.textContent = w.length || ''; c.dataset.count = w.length; });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]'); if (!b) return; e.preventDefault();
    const h = b.dataset.wish; const w = getW(); const i = w.indexOf(h);
    if (i > -1) { w.splice(i, 1); toast('Retiré de votre liste d’envies'); } else { w.push(h); toast('Ajouté à votre liste d’envies'); }
    setW(w); $$(`[data-wish="${h}"]`).forEach((x) => { x.classList.remove('is-pop'); void x.offsetWidth; x.classList.add('is-pop'); });
    if (b.closest('[data-wishlist-page]')) renderWishlist();
  });
  async function renderWishlist() {
    const host = $('[data-wishlist-grid]'); if (!host) return;
    const w = getW(); const empty = $('[data-wishlist-empty]');
    if (!w.length) { host.innerHTML = ''; empty && (empty.hidden = false); return; }
    empty && (empty.hidden = true);
    const parts = await Promise.all(w.map((h) => fetch(`${rootUrl}products/${encodeURIComponent(h)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    host.innerHTML = parts.join(''); syncW();
  }
  syncW(); renderWishlist();

  /* ---------- cart ---------- */
  const drawer = $('[data-cart-drawer]');
  function setCount(n) { $$('[data-cart-count]').forEach((c) => { c.textContent = n || ''; c.dataset.count = n; }); }
  function renderDrawer(html) {
    if (!html || !drawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html'); const panel = $('.drawer__panel', doc);
    if (panel) $('.drawer__panel', drawer).innerHTML = panel.innerHTML;
  }
  function openCart() { if (!drawer) { window.location.href = T.routes.cart; return; } openLayer(drawer); }
  async function cartPost(url, body) {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname }) });
    const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Erreur');
    return j;
  }
  async function refreshCount() { try { const c = await (await fetch(rootUrl + 'cart.js')).json(); setCount(c.item_count); } catch (e) {} }
  async function addToCart(items, btn) {
    btn && btn.setAttribute('aria-busy', 'true'); btn && (btn.disabled = true);
    try {
      const j = await cartPost((T.routes.cartAdd || '/cart/add') + '.js', { items });
      if (j.sections) renderDrawer(j.sections['cart-drawer']);
      await refreshCount(); openCart();
    } catch (err) { toast(err.message || 'Impossible d’ajouter cet article'); }
    finally { btn && btn.removeAttribute('aria-busy'); btn && (btn.disabled = false); }
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]'); if (q) { e.preventDefault(); addToCart([{ id: Number(q.dataset.quickAdd), quantity: 1 }], q); return; }
    const p = e.target.closest('[data-add-many]'); if (p) { e.preventDefault(); addToCart(p.dataset.addMany.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 })), p); return; }
    const oc = e.target.closest('[data-open-cart]'); if (oc && drawer) { e.preventDefault(); openCart(); }
  });
  if (drawer) drawer.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-line]'); if (!line) return;
    const qb = e.target.closest('[data-qty-change]'); const rm = e.target.closest('[data-remove]'); if (!qb && !rm) return;
    const cur = parseInt($('.qty span', line).textContent, 10) || 0;
    const quantity = rm ? 0 : Math.max(0, cur + parseInt(qb.dataset.qtyChange, 10));
    line.classList.add('is-busy');
    try { const j = await cartPost((T.routes.cartChange || '/cart/change') + '.js', { line: Number(line.dataset.line), quantity }); setCount(j.item_count); if (j.sections) renderDrawer(j.sections['cart-drawer']); }
    catch (err) { toast(err.message); line.classList.remove('is-busy'); }
  });

  /* ---------- product form ---------- */
  $$('[data-product]').forEach((pdp) => {
    const data = JSON.parse(($('[data-product-json]', pdp) || {}).textContent || '{}'); if (!data.variants) return;
    const form = $('form[data-product-form]', pdp); const idInput = $('input[name="id"]', form);
    const addBtn = $('[data-add]', pdp); const nowBtn = $('[data-buy-now]', pdp); const priceHost = $('[data-price-host]', pdp);
    const money = (c) => formatMoney(c, T.money);
    const current = () => { const sel = $$('[data-option]', pdp).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; }); return data.variants.find((v) => v.options.every((o, i) => sel[i] == null || o === sel[i])); };
    function update(init) {
      const v = current();
      $$('[data-option]', pdp).forEach((fs) => { const c = $('input:checked', fs); const out = $('[data-option-value]', fs); if (c && out) out.textContent = c.value; });
      if (!v) { addBtn.disabled = true; addBtn.querySelector('span').textContent = 'Indisponible'; return; }
      idInput.value = v.id; addBtn.disabled = !v.available; nowBtn && (nowBtn.disabled = !v.available);
      addBtn.querySelector('span').textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (priceHost) {
        let h = `<span class="price__now">${money(v.price)}</span>`;
        if (v.compare_at_price > v.price) h = `<span class="visually-hidden">Prix promotionnel</span><span class="price__now">${money(v.price)}</span><span class="visually-hidden">Prix habituel</span><s class="price__was">${money(v.compare_at_price)}</s><span class="price__save">-${Math.round((1 - v.price / v.compare_at_price) * 100)} %</span>`;
        priceHost.innerHTML = h; priceHost.classList.toggle('price--sale', v.compare_at_price > v.price);
      }
      $$('[data-sticky-price]').forEach((s) => (s.textContent = money(v.price)));
      // the selected variant (default or ?variant=) always shows its own image; on first load jump without animation
      if (v.featured_media && v.featured_media.id) gotoMedia(String(v.featured_media.id), init);
      if (init) return;
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
    }
    pdp.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) update(); });
    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart([{ id: Number(idInput.value), quantity: 1 }], addBtn); });
    nowBtn && nowBtn.addEventListener('click', async () => {
      nowBtn.disabled = true;
      try { await cartPost((T.routes.cartAdd || '/cart/add') + '.js', { items: [{ id: Number(idInput.value), quantity: 1 }] }); window.location.href = '/checkout'; }
      catch (err) { toast(err.message); nowBtn.disabled = false; }
    });
    $$('[data-sticky-add]').forEach((b) => b.addEventListener('click', () => addToCart([{ id: Number(idInput.value), quantity: 1 }], b)));

    // gallery
    const slidesWrap = $('.gallery__slides', pdp); const slides = $$('.gallery__slide', pdp); const thumbs = $$('.gallery__thumb', pdp); const count = $('[data-gallery-count]', pdp);
    function mark(i) { thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false')); if (count) count.textContent = `${i + 1} / ${slides.length}`; }
    function gotoIndex(i, instant) { if (!slidesWrap || !slides[i]) return; slidesWrap.scrollTo({ left: slides[i].offsetLeft, behavior: reduce || instant ? 'auto' : 'smooth' }); mark(i); }
    function gotoMedia(id, instant) { const i = slides.findIndex((s) => s.dataset.mediaId === id); if (i > -1) gotoIndex(i, instant); }
    thumbs.forEach((t, i) => t.addEventListener('click', () => gotoIndex(i)));
    slidesWrap && slidesWrap.addEventListener('scroll', () => { const i = Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth); mark(i); }, { passive: true });
    // zoom: click toggles 2x, pointer pans
    slides.forEach((s) => {
      s.addEventListener('click', () => { s.classList.toggle('is-zoom'); });
      s.addEventListener('pointermove', (e) => { if (!s.classList.contains('is-zoom')) return; const r = s.getBoundingClientRect(); s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
      s.addEventListener('pointerleave', () => s.classList.remove('is-zoom'));
    });
    const zb = $('.gallery__zoom', pdp); zb && zb.addEventListener('click', (e) => { e.stopPropagation(); const i = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'); const s = slides[Math.max(0, i)]; s && s.classList.toggle('is-zoom'); });

    // sticky buy bar (mobile)
    const sticky = $('.sticky-buy'); if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
    }
    update(true);
  });

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach((w) => {
    const tabs = $$('[role="tab"]', w);
    const sel = (t) => { tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; }); };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => sel(t));
      t.addEventListener('keydown', (e) => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); const n = tabs[(i + d + tabs.length) % tabs.length]; sel(n); n.focus(); });
    });
  });

  /* ---------- collection: sort + filters ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); }));

  /* ---------- clover cursor (fine pointers) ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduce) {
    const cur = document.createElement('div'); cur.className = 'cursor'; cur.innerHTML = CLOVER; document.body.appendChild(cur);
    let x = 0, y = 0, on = false;
    document.addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; cur.style.left = x + 'px'; cur.style.top = y + 'px'; const hit = e.target.closest('.card__media, .tile, .ugc a, .focus__slide.is-active .card__media'); if (!!hit !== on) { on = !!hit; cur.classList.toggle('is-on', on); } }, { passive: true });
  }

  /* ---------- newsletter success flag ---------- */
  if (/customer_posted=true/.test(window.location.search) || /#newsletter-ok/.test(window.location.hash)) toast('Merci ! Votre code -10 % arrive par e-mail.');
})();
